<template>
  <div id="app">
    <div
      v-if="dataReady"
      :class="{ 'rg-drawer-open': isDrawerOpen }"
      class="application-wrap">

      <nav
        class="rg-toolbar">
        <div class="rg-toolbar-content">
          <span v-html="siteMeta.logo" @click="setAboutVisible(true)"></span>
          <span class="rg-toolbar-title">{{ siteMeta.name }}</span>

          <span class="rg-toolbar-tagline">{{ siteMeta.tagline }}</span>

          <div class="rg-spacer"></div>

          <ranger-view></ranger-view>

          <place-search-view></place-search-view>
          <!-- v-ripple -->
          <div class="rg-btn rg-toolbar-side-icon"
            @click="toggleDrawer">
            <i aria-hidden="true" class="rg-icon material-icons">layers</i>
          </div>
        </div>
      </nav>

      <div class="rg-main-content">
        <main class="rg-content">
            <map-view></map-view>
        </main>

        <navigation-view></navigation-view>
      </div>

      <details-view
        id="rg-details">
      </details-view>
      <reader-view
        v-if="siteMeta.hasReader"
        id="rg-reader">
      </reader-view>
      <about-view></about-view>
    </div>
    <div
      v-else
      class="application-wrap loading-screen">
      <div id="update-message">
        <img id="update-loader-overlay" src="static/loader-icon.svg"/>
        <img id="update-logo" src="static/rg-logo.svg">Checking for fresh data...
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import debounce from 'lodash.debounce';
import MapView from './components/MapView.vue';
import DetailsView from './components/DetailsView.vue';
import ReaderView from './components/ReaderView.vue';
import AboutView from './components/AboutView.vue';
import NavigationView from './components/NavigationView.vue';
import PlaceSearchView from './components/PlaceSearchView.vue';
import RangerView from './components/RangerView.vue';

export default {
  name: 'app',

  components: {
    MapView,
    NavigationView,
    AboutView,
    DetailsView,
    PlaceSearchView,
    RangerView,
    ReaderView,
  },

  computed: {
    ...mapState([
      'siteMeta',
      'siteId',
      'isDrawerOpen',
      'dataReady',
    ]),
  },

  beforeCreate() {
    this.$store.commit('INITALIZE_STORE');
  },

  created() {
    document.addEventListener('resize', debounce(() => this.onResize, 500));
  },

  beforeDestroy() {
    document.removeEventListener('resize', this.onResize);
  },

  mounted() {
    // open drawer for medium tablet and up
    this.setDrawerOpen(!(window.innerWidth <= 960));
    this.onResize();
  },

  methods: {
    ...mapActions([
      'setDrawerOpen',
      'setAboutVisible',
      'initalizeLayers',
    ]),

    linkto(pathname) {
      this.$router.push({ path: pathname });
    },

    toggleDrawer() {
      this.setDrawerOpen(!this.isDrawerOpen);
      this.onResize();
    },

    onResize() {
      this.$bus.$emit('map-resize');
    },

  },
};
</script>

<style scoped lang="less">
@import "./assets/less/variables.less";

.application-wrap.loading-screen {
    justify-content: center;
    align-content: center;

  #update-message {
    align-self: center;
    flex: 0 0 46px;
    justify-self: center;
    display: flex;
    align-items: center;
    justify-items: center;
    position: relative;

    #update-loader-overlay {
      position: absolute;
      top: 2px;
      left: 0;
    }

    img {
      width: 40px;
      height: 40px;
      margin-right: 8px;
    }
  }
}

.rg-toolbar {
  flex: 0 0 56px;
}

.rg-main-content {
  display: flex;
}

</style>
